import { useCallback } from 'react';
import { useRegisterContext } from '../reducer/useRegister';
import { createAccount, verifyOtp } from '../../rest-api/request';
import { parseAuthError } from '../../rest-api/utils';
import { persistAuthResult } from '@xolv-mybrightlink/common';

export const useCreateAccount = () => {
  const [state, dispatch] = useRegisterContext();
  const { data } = state;
  return useCallback(
    async (otp: string) => {
      if (data.type !== 'CREATE_ACCOUNT') {
        return;
      }
      const { phoneNumber, zipCode, sfContactId, agreementTime } = data;
      dispatch('LOADING');
      try {
        await createAccount(
          phoneNumber,
          zipCode,
          sfContactId,
          otp,
          agreementTime,
          agreementTime,
        );
        const authResult = await verifyOtp(phoneNumber, otp);
        persistAuthResult(authResult.access_token, authResult.refresh_token);
        dispatch({
          type: 'REGISTERED',
          phoneNumber,
        });
      } catch (error) {
        dispatch({ ...data, error: getErrorReason(error) });
      }
    },
    [data, dispatch],
  );
};

const getErrorReason = (error: unknown) => {
  const errorResponse = parseAuthError(error);
  const errorCode = errorResponse?.error_code;
  if (errorCode === 'INVALID_APPLICATION_TOKEN') {
    return 'bad-credentials';
  }
  return 'generic-error';
};
